import React, { useEffect, useState } from "react";
import NavBar from "../navBar/NavBar";
import "../../styles/gridBackground.css";
import TextImage from "../../assets/images/Frame 1171279424 (1).png";
import WobbleCards from "../../ui/WobbleCard";
import { HowItsWorks } from "../howItsWorks/HowItsWorks";
import {Testimonials} from "../testimonials/Testimonials";

const GridBackgroundDemo = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <NavBar />
      <div style={{ padding: 20, background: "#000" }}>
        {/* Image Section */}
        <div
          className="fade-in"
          style={{
            marginTop: 20,
            marginBottom: isMobile ? 20 : 80,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={TextImage}
            alt="Text Image"
            className="grid-image"
            style={{
              width: "100vw",
              height: "auto",
              borderRadius: "20px",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Background Grid Section */}
        <div
          // className="grid-background"
          style={{
            flexDirection: "column",
            paddingBottom: isMobile ? 10 : 100,
          }}
        >
          {/* Center Faded Radial Overlay */}
          {/* <div className="grid-overlay"></div> */}

          {/* Wobble Cards Section */}
          <div className="fade-in" style={{ marginTop: 50 }}>
            <WobbleCards />
          </div>

          {/* Sticky Scroll Section */}
          <div style={{ marginTop: isMobile ? 20 : 50 }}>
            <HowItsWorks />
          </div>

          {/* Testimonials Section */}
          <Testimonials />
        </div>
      </div>
    </>
  );
};

export default GridBackgroundDemo;
